
import request from '@/utils/request'
import { isUseAPI } from '@/utils/check'

/**
 * 개인정보 접속기록 조회 (개인정보보호법 준수 - 1년 이상 보관)
 * @param {Object} param - { userId, startDate(YYYYMMDD), endDate(YYYYMMDD), ipAddr, operationType, subjectId }
 */
export function getPersonalInfoAccessLog(param) {
  return request({
    url: '/log/access',
    method: 'get',
    params: {
      userId: param.userId || '',
      startDate: param.startDate || '',
      endDate: param.endDate || '',
      ipAddr: param.ipAddr || '',
      operationType: param.operationType || '',
      subjectId: param.subjectId || ''
    }
  })
}

export function searchLoginHistory(param) {
  console.log(param)
  if (isUseAPI()) {
    return request({
      url: `/log/login?${param.userId !== undefined ? 'userId=' + param.userId : ''}&${param.startDate !== undefined ? 'startDate=' + param.startDate : ''}&${param.endDate !== undefined ? 'endDate=' + param.endDate : ''}`,
      method: 'get'
    })
  }
}

export function getLoginHistory(retrieveObj) {
  if (true) {
    let params = { app_id: retrieveObj.app_id }
    if (retrieveObj.user_id && !retrieveObj.start_date && !retrieveObj.end_date) params = { app_id: retrieveObj.app_id, user_id: retrieveObj.user_id }
    else if (retrieveObj.user_id && retrieveObj.start_date && retrieveObj.end_date) {
      params = { app_id: retrieveObj.app_id, user_id: retrieveObj.user_id, start_date: retrieveObj.start_date, end_date: retrieveObj.end_date }
    } else if (retrieveObj.start_date && retrieveObj.end_date) {
      params = { app_id: retrieveObj.app_id, start_date: retrieveObj.start_date, end_date: retrieveObj.end_date }
    }
    return request({
      url: `/hiway/log/login`,
      method: 'get',
      meta: { apiVersion: '2.0.0' },
      params
    })
  }

  return new Promise(function(resolve, reject) {
    resolve()
  })
}
export function getAuthHistory(retrieveObj) {
  if (true) {
    let params = { app_id: retrieveObj.app_id }
    if (retrieveObj.authgrp_cd && !retrieveObj.start_date && !retrieveObj.end_date) params = { app_id: retrieveObj.app_id, authgrp_cd: retrieveObj.authgrp_cd }
    else if (retrieveObj.authgrp_cd && retrieveObj.start_date && retrieveObj.end_date) {
      params = { app_id: retrieveObj.app_id, authgrp_cd: retrieveObj.authgrp_cd, start_date: retrieveObj.start_date, end_date: retrieveObj.end_date }
    } else if (retrieveObj.start_date && retrieveObj.end_date) {
      params = { app_id: retrieveObj.app_id, start_date: retrieveObj.start_date, end_date: retrieveObj.end_date }
    }
    return request({
      url: `/hiway/log/authgroup`,
      method: 'get',
      meta: { apiVersion: '2.0.0' },
      params
    })
  }

  return new Promise(function(resolve, reject) {
    resolve()
  })
}
export function getAuthUserHistory(retrieveObj) {
  if (true) {
    let params = { app_id: retrieveObj.app_id }
    if (retrieveObj.authgrp_cd && !retrieveObj.start_date && !retrieveObj.end_date) params = { app_id: retrieveObj.app_id, authgrp_cd: retrieveObj.authgrp_cd }
    else if (retrieveObj.authgrp_cd && retrieveObj.start_date && retrieveObj.end_date) {
      params = { app_id: retrieveObj.app_id, authgrp_cd: retrieveObj.authgrp_cd, start_date: retrieveObj.start_date, end_date: retrieveObj.end_date }
    } else if (retrieveObj.start_date && retrieveObj.end_date) {
      params = { app_id: retrieveObj.app_id, start_date: retrieveObj.start_date, end_date: retrieveObj.end_date }
    }
    return request({
      url: `/hiway/log/authuser`,
      method: 'get',
      meta: { apiVersion: '2.0.0' },
      params
    })
  }

  return new Promise(function(resolve, reject) {
    resolve()
  })
}

export function getAuthMenuHistory(retrieveObj) {
  if (true) {
    let params = { app_id: retrieveObj.app_id }
    if (retrieveObj.authgrp_cd && !retrieveObj.start_date && !retrieveObj.end_date) params = { app_id: retrieveObj.app_id, authgrp_cd: retrieveObj.authgrp_cd }
    else if (retrieveObj.authgrp_cd && retrieveObj.start_date && retrieveObj.end_date) {
      params = { app_id: retrieveObj.app_id, authgrp_cd: retrieveObj.authgrp_cd, start_date: retrieveObj.start_date, end_date: retrieveObj.end_date }
    } else if (retrieveObj.start_date && retrieveObj.end_date) {
      params = { app_id: retrieveObj.app_id, start_date: retrieveObj.start_date, end_date: retrieveObj.end_date }
    }
    return request({
      url: `/hiway/log/authmenu`,
      method: 'get',
      meta: { apiVersion: '2.0.0' },
      params
    })
  }

  return new Promise(function(resolve, reject) {
    resolve()
  })
}

export function getMenuHistory(retrieveObj) {
  if (true) {
    let params = { app_id: retrieveObj.app_id }
    if (retrieveObj.user_id && !retrieveObj.start_date && !retrieveObj.end_date) params = { app_id: retrieveObj.app_id, user_id: retrieveObj.user_id }
    else if (retrieveObj.user_id && retrieveObj.start_date && retrieveObj.end_date) {
      params = { app_id: retrieveObj.app_id, user_id: retrieveObj.user_id, start_date: retrieveObj.start_date, end_date: retrieveObj.end_date }
    } else if (retrieveObj.start_date && retrieveObj.end_date) {
      params = { app_id: retrieveObj.app_id, start_date: retrieveObj.start_date, end_date: retrieveObj.end_date }
    }
    return request({
      url: `/hiway/log/menu`,
      method: 'get',
      meta: { apiVersion: '2.0.0' },
      params
    })
  }

  return new Promise(function(resolve, reject) {
    resolve()
  })
}
